export default {
    en: {
        all_transfers: 'All transfers',
        not_found: 'Transfer not found',
        status: 'Status',
        time_to_pay: 'Pay the transfer within',
        check_details: 'Check the recipient details before paying',
        amount: 'Amount',
        to: 'to',
        recipient_info: 'Recipient info',
        phone_number: 'Phone number',
        card_number: 'Card number',
        bank: 'Bank',
        account_number: 'Account number',
        payment_system: 'Payment system',
        pay: 'Pay by',
        cancel_transfer: 'Cancel transfer',
        confirm: 'Confirm',
        confirmed: 'Confirmed',
        confirmed_text: 'Transfer confirmed',
        error: 'Error',
        paid_success: 'Success',
        paid_success_text: 'Payment was successful',
        not_paid: 'Not paid',
        not_paid_text: 'The transfer has not been paid yet',
        cancel: 'Cancel',
        canceled: 'Canceled',
        canceled_text: 'Transfer canceled',
        confirm_paid: 'Confirm the payment of the transfer?',
        confirm_got: 'Confirm the receipt of the transfer?',
        confirm_cancel: 'Confirm the cancellation of the transfer?',
        sign_paid: 'Mark the transfer as paid or cancel',
        sign_confirmed: 'Mark that you received the transfer',
        help: 'Help',
        sent: 'I sent',
        check_payment: 'Check the payment',
        got: 'I got',
        last_step_card_left: 'Get the transfer to the card',
        last_step_card_right: 'within 15 minutes',
        last_step_cash: 'Get a code to withdraw cash at an ATM',
        copied: 'Copied',
        files: 'Transfer bills',
        download: 'Download',
        view: 'View',
        file: 'File',
        attach_qr: 'Attach a QR code for payout to {bank}',
        qr_attached: 'Requisite attached',

        // отзыв
        rev_title: 'Did you like it?',
        rev_good: 'Great',
        rev_bad: 'Not really',
        rev_title_good: 'What did you like the most?',
        rev_title_bad: 'What did you not like?',
        rev_comment: 'Write a couple of kind words about us?',
        rev_send: 'Send',
        rev_msg_success_title: 'Success',
        rev_msg_success_text: 'Thank you for your feedback!',
        rev_msg_error_title: 'Error',
        rev_msg_error_text: 'Something went wrong',
    },
    ru: {
        all_transfers: 'Все переводы',
        not_found: 'Перевод не найден',
        status: 'Статус',
        time_to_pay: 'Оплатите перевод в течение',
        check_details: 'Проверьте реквизиты получателя перед оплатой',
        amount: 'Сумма',
        to: 'на',
        recipient_info: 'Информация о получателе',
        phone_number: 'Номер телефона',
        card_number: 'Номер карты',
        bank: 'Банк',
        account_number: 'Номер счета',
        payment_system: 'Платежная система',
        pay: 'Оплатить',
        cancel_transfer: 'Отменить перевод',
        confirm: 'Подтверждаю',
        confirmed: 'Подтверждено',
        confirmed_text: 'Перевод подтвержден',
        error: 'Ошибка',
        paid_success: 'Успех',
        paid_success_text: 'Оплата прошла успешно',
        not_paid: 'Не оплачено',
        not_paid_text: 'Перевод еще не оплачен',
        cancel: 'Отмена',
        canceled: 'Отменено',
        canceled_text: 'Перевод отменен',
        confirm_paid: 'Подтверждаете оплату перевода?',
        confirm_cancel: 'Подтверждаете отмену перевода?',
        confirm_got: 'Подтвердите получение перевода?',
        sign_paid: "Отметьте перевод как выполненный или отмените",
        sign_confirmed: "Отметьте что получили перевод",
        help: 'Помощь',
        sent: 'Я отправил',
        check_payment: 'Проверить оплату',
        got: 'Я получил',
        last_step_card_left: 'Получите перевод на карту',
        last_step_card_right: 'в течение 15 минут',
        last_step_cash: 'Получите код для снятия наличных в банкомате',
        copied: 'Скопировано',
        files: 'Чеки по переводу',
        download: 'Скачать',
        view: 'Посмотреть',
        file: 'Файл',
        attach_qr: 'Приложите QR код для выплаты на {bank}',
        qr_attached: 'Реквизит прикреплен',

        // отзыв
        rev_title: 'Вам понравилось?',
        rev_good: 'Отлично',
        rev_bad: 'Не очень',
        rev_title_good: 'Что вам понравилось больше всего?',
        rev_title_bad: 'Что вам не понравилось?',
        rev_comment: 'Напишите пару ласковых о нас?',
        rev_send: 'Отправить',
        rev_msg_success_title: 'Успех',
        rev_msg_success_text: 'Спасибо за отзыв!',
        rev_msg_error_title: 'Ошибка',
        rev_msg_error_text: 'Что-то пошло не так',
    }
}